import { Route, Switch, Redirect } from 'react-router-dom';
import { isLogin } from './Helpers/request';
import Myaccount from './Containers/Pages/Myaccount';
import Register from './Containers/Pages/Register';
import Productdetails from './Containers/Shopping/productDetails';
import Invoice from './Containers/Pages/invoice';
import Cart from './Containers/Pages/cart';
import Services from './Containers/Pages/Static/Services';
import Checkout from './Containers/Pages/checkout';
import customDesigns from './Containers/Pages/Static/customDesigns';
import Financing from './Containers/Pages/Static/financing';
import Education from './Containers/Pages/Static/education';
import EducationGoldBuying from './Containers/Pages/Static/education-gold-buying';
import EducationDiamondBuying from './Containers/Pages/Static/education-diamond-buying';
import EducationJewelryCare from './Containers/Pages/Static/education-jewelry-care';
import EducationMetals from './Containers/Pages/Static/education-metals';
import EducationSettings from './Containers/Pages/Static/education-settings';
import EducationDiamonds from './Containers/Pages/Static/education-diamonds';
import MakeAnAppointment from './Containers/Pages/make-an-appointment';
import PressMedia from './Containers/Pages/Static/press-media';
import Charities from './Containers/Pages/Static/charities';
import Testimonials from './Containers/Pages/Static/testimonials';
import Contact from './Containers/Pages/Static/contact';
import ResponsibleSourcing from './Containers/Pages/Static/responsible-sourcing';
import WarrantyGuarantees from './Containers/Pages/Static/warranty-and-guarantees';
import MilitaryDiscount from './Containers/Pages/Static/military-discount';
import Careers from './Containers/Pages/Static/careers';
import PrivacyPolicy from './Containers/Pages/Static/privacy-policy';
import TermsConditions from './Containers/Pages/Static/terms-and-conditions';
import MissionVision from './Containers/Pages/Static/mission-and-vision';
import AdaCompliance from './Containers/Pages/Static/ada-compliance';
import SellYourJewelry from './Containers/Pages/Static/sell-your-jewelry';
import Insurance from './Containers/Pages/Static/insurance';
import GiftGuide from './Containers/Pages/Static/gift-guide';
import OurStory from './Containers/Pages/Static/our-story';
import IndianJewelry from './Containers/Pages/Static/indian-jewelry';
import Blog from './Containers/Pages/Static/blog';
import { ordersuccess } from './Containers/Pages/Static/ordersuccess';
import NoPage from "./Containers/Pages/Static/NoPage"
import Wishlist from './Containers/Pages/wishlist';
import blogDetails from './Containers/Pages/Static/blogDetails';
import PressMediaDetails from './Containers/Pages/Static/press-media-details';
import RingSettings from './Containers/Shopping/ringsettings';
import RingSettingsDiamonds from './Containers/Shopping/ringsettings-diamonds';
import RingSettingsDiamondsDetails from './Containers/Shopping/ringsettings-diamonds-details';
import Gemstones from './Containers/Shopping/gemstone';
import CompleteRing from './Containers/Shopping/complete-ring';
import GemstonesDetails from './Containers/Shopping/gemstone-details';
import EducationalBlog from './Containers/Pages/Static/EducationalBlog';
import FancyColorDiamond from './Containers/Shopping/FancyColorDiamond';
import Fancycolordetail from './Containers/Shopping/fancy-detail';
import FAQ from './Containers/Pages/Static/faq';
import Productlist from './Containers/Shopping/productlist';
import Home from './Containers/Front/Home';
import ForgotPass from './Components/ForgotPass';
import Login from './Components/Login';
import React, { useEffect } from 'react';
import WarrantyRegistration from './Containers/Pages/WarrantyRegistration';
import DiamondsStaticPage from './Containers/Pages/DiamondsLandingPage/DiamondsStaticPage';
import EngagmentStaticPage from './Containers/Pages/EngagementLandingPage/EngagmentStaticPage';
import WeddingRingStaticPage from './Containers/Pages/WeddingRingLandingPage/WeddingRingStaticPage';
import FineJeweleryStaticPage from './Containers/Pages/FineJwelleryLandingPage/FineJeweleryStaticPage';
import EngagementRingsToronto from './Containers/Pages/Static/engagementRingsToronto';
import DiamondEarrings from './Containers/Pages/Static/diamondEarrings';
import Redirection from './Components/Redirection';
import AllCustomer from './Containers/Front/AllCustomer';
import HolidayGift from './Containers/Pages/Static/HolidayGift';
import DiamondEngagementRing from './Containers/Pages/Static/diamond-engagement-ring';
import WeddingBands from './Containers/Pages/Wedding-band';
const Mainrouter = () => {

  // remove "/" from last of ulrs
  var url_view = window.location.href;
var url_path = window.location.pathname;
var url_hash = window.location.hash;
  useEffect(() => {
    if(url_path.endsWith("/") || url_hash.endsWith("/")) {
      if(url_path !== "/"){
        url_view = url_view.slice(0,-1);
        window.location.replace(url_view);
      }
  }
  }, [])
  if (isLogin) {
    return (
      <Switch>
        <Route path="/account/:value" component={Myaccount} />
        <Route path="/invoice/:order_id" component={Invoice} />
        <Route path="/jewellery/wedding-anniversary-bands" component={WeddingRingStaticPage} />
        <Route path="/jewellery/:listcategory/:slug" component={Productlist} />
        <Route path="/jewellery/:listcategory" component={Productlist} />
        <Route path="/jewellery" component={FineJeweleryStaticPage} />
        <Route path="/ringsettings" component={RingSettings} />
        <Route path="/ringsettings/:stone" component={RingSettings} />
        <Route path="/ringsettingdetail/:id/:slug" component={Productdetails} />
        <Route path="/gemstones" component={Gemstones} />
        <Route path="/fancy-color-diamond" component={FancyColorDiamond} />
        <Route path="/fancy-color-diamond-detail/:stock_no" component={Fancycolordetail} />
        <Route path="/diamonds" component={RingSettingsDiamonds} />
        <Route path="/diamonds/lab" component={RingSettingsDiamonds} />
        <Route path="/diamonds-details/:stock_no" component={RingSettingsDiamondsDetails} />
        <Route path="/gemstone-details/:stock_no" component={GemstonesDetails} />
        <Route path="/complete-diamond-ring" component={CompleteRing} />
        <Route path="/complete-gemstone-ring" component={CompleteRing} />
        <Route path="/complete-fancycolor-ring" component={CompleteRing} />
        <Route path="/search/:search_text" component={Productlist} />
        <Route path="/services" component={Services} />
        <Route path="/cart" component={Cart} />
        {/* <Route path="/checkout-shipping" component={Checkout} /> */}
        <Route path="/custom-jewelry-toronto-2" component={customDesigns} />
        <Route path="/financing" component={Financing} />
        <Route path="/education" component={Education} />
        <Route path="/education-gold-buying" component={EducationGoldBuying} />
        <Route path="/education-diamond-buying" component={EducationDiamondBuying} />
        <Route path="/education-jewelry-care" component={EducationJewelryCare} />
        <Route path="/education-metals" component={EducationMetals} />
        <Route path="/education-settings" component={EducationSettings} />
        <Route path="/education-diamonds" component={EducationDiamonds} />
        <Route path="/make-an-appointment" component={MakeAnAppointment} />
        <Route path="/press-media" component={PressMedia} />
        <Route path="/press-media-details/:id" component={PressMediaDetails} />
        <Route path="/charities" component={Charities} />
        <Route path="/testimonials" component={Testimonials} />
        <Route path="/contact-us" component={Contact} />
        <Route path="/responsible-sourcing" component={ResponsibleSourcing} />
        <Route path="/warranty" component={WarrantyGuarantees} />
        {/* <Route path="/military-discount" component={MilitaryDiscount} /> */}
        <Route path="/careers" component={Careers} />
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="/terms-conditions" component={TermsConditions} />
        <Route path="/mission-and-vision" component={MissionVision} />
        {/* <Route path="/ada-compliance" component={AdaCompliance} /> */}
        <Route path="/sell-your-jewelry" component={SellYourJewelry} />
        {/* <Route path="/insurance" component={Insurance} /> */}
        {/* <Route path="/2021-gift-guide" component={GiftGuide} /> */}
        <Route path="/about-diamonds-for-less" component={OurStory} />
        {/* <Route path="/indian-jewelry" component={IndianJewelry} /> */}
        <Route path = "/diamond-engagement-rings" component={DiamondEngagementRing}/>
        <Route path="/blog" component={Blog} />
        <Route path="/faq" component={FAQ} />
        <Route path="/all-customer" component={AllCustomer} />
        {/* <Route path="/blog-details/:url" component={blogDetails} /> */}
        <Route path="/educational-blog" component={EducationalBlog} />
        <Route path="/wishlist" render={() =>
        (
          <Redirect to="/account/wishlist" />
        )
        } />
        <Route path="/productdetail/:slug" component={Productdetails} />
        <Route path="/ordersuccess/:order_id/:order_no/:txn_id" component={ordersuccess} />
        <Route path="/warranty-registration" component={WarrantyRegistration} />
        <Route exact path="/wholesale-diamonds-for-sale-toronto" component={DiamondsStaticPage} />
        <Route path="/diamond-earrings" component={DiamondEarrings} />
        <Route path="/holiday-gift-guide-2023" component={HolidayGift} />
        <Route path="/wedding-bands" component={WeddingBands} />
        <Route path='*' exact={true} component={Redirection} />
      </Switch>
    )
  } else {
    return (
      <Switch>
        <Route path="/account/:value" component={Home} />
        <Route path="/invoice/:order_id" component={Home} />
        <Route exact path="/jewellery/wedding-anniversary-bands" component={WeddingRingStaticPage} />
        <Route path="/jewellery/:listcategory/:slug" component={Productlist} />
        <Route path="/jewellery/:listcategory" component={Productlist} />
        <Route path="/jewellery" component={FineJeweleryStaticPage} />
        <Route path="/ringsettings" component={RingSettings} />
        <Route path="/ringsettings/:stone" component={RingSettings} />
        <Route path="/ringsettingdetail/:id/:slug" component={Productdetails} />
        <Route path="/gemstones" component={Gemstones} />
        <Route path="/fancy-color-diamond" component={FancyColorDiamond} />
        <Route path="/fancy-color-diamond-detail/:stock_no" component={Fancycolordetail} />
        <Route path="/diamonds" component={RingSettingsDiamonds} />
        <Route path="/diamonds/lab" component={RingSettingsDiamonds} />
        <Route path="/all-customer" component={AllCustomer} />
        <Route path="/diamonds-details/:stock_no" component={RingSettingsDiamondsDetails} />
        <Route path="/gemstone-details/:stock_no" component={GemstonesDetails} />
        <Route path="/complete-diamond-ring" component={CompleteRing} />
        <Route path="/complete-gemstone-ring" component={CompleteRing} />
        <Route path="/complete-fancycolor-ring" component={CompleteRing} />
        <Route path="/search/:search_text" component={Productlist} />
        <Route path="/services" component={Services} />
        <Route path="/register" component={Register} />
        <Route path="/forgot" component={ForgotPass} />
        <Route path="/login" component={Login} />
        <Route path="/cart" component={Cart} />
        <Route path="/checkout-shipping" component={Checkout} />
        <Route path="/custom-jewelry-toronto-2" component={customDesigns} />
        <Route path="/financing" component={Financing} />
        <Route path="/education" component={Education} />
        <Route path="/education-gold-buying" component={EducationGoldBuying} />
        <Route path="/education-diamond-buying" component={EducationDiamondBuying} />
        <Route path="/education-jewelry-care" component={EducationJewelryCare} />
        <Route path="/education-metals" component={EducationMetals} />
        <Route path="/education-settings" component={EducationSettings} />
        <Route path="/education-diamonds" component={EducationDiamonds} />
        <Route path="/make-an-appointment" component={MakeAnAppointment} />
        <Route path="/press-media" component={PressMedia} />
        <Route path="/press-media-details/:id" component={PressMediaDetails} />
        <Route path="/charities" component={Charities} />
        <Route path="/testimonials" component={Testimonials} />
        <Route path="/contact-us" component={Contact} />
        <Route path="/responsible-sourcing" component={ResponsibleSourcing} />
        <Route path="/warranty" component={WarrantyGuarantees} />
        {/* <Route path="/military-discount" component={MilitaryDiscount} /> */}
        <Route path="/careers" component={Careers} />
        {/* <Route path="/returns-and-exchanges" component={ReturnsExchanges} /> */}
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="/terms-conditions" component={TermsConditions} />
        <Route path="/mission-and-vision" component={MissionVision} />
        {/* <Route path="/ada-compliance" component={AdaCompliance} /> */}
        <Route path="/sell-your-jewelry" component={SellYourJewelry} />
        <Route path="/about-diamonds-for-less" component={OurStory} />
        {/* <Route path="/indian-jewelry" component={IndianJewelry} /> */}
        <Route path = "/diamond-engagement-rings" component={DiamondEngagementRing}/>
        <Route path="/blog" component={Blog} />
        <Route path="/faq" component={FAQ} />
        {/* <Route path="/blog-details/:url" component={blogDetails} /> */}
        <Route path="/educational-blog" component={EducationalBlog} />
        <Route path="/wishlist" component={Wishlist} />
        <Route path="/productdetail/:slug" component={Productdetails} />
        <Route path="/ordersuccess/:order_id/:order_no/:txn_id" component={ordersuccess} />
        <Route path="/warranty-registration" component={WarrantyRegistration} />
        <Route exact path="/wholesale-diamonds-for-sale-toronto" component={DiamondsStaticPage} />
        <Route path="/diamond-earrings" component={DiamondEarrings} />
        <Route path="/holiday-gift-guide-2023" component={HolidayGift} />
        <Route path="/wedding-bands" component={WeddingBands} />
        <Route path='*' exact={true} component={Redirection} />
      </Switch>
    )
  }
}

export default React.memo(Mainrouter);